import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
    ShieldCheck,
    ArrowRight,
    Mail,
    Lock,
    Sparkles
} from 'lucide-react';
import Header from '../header';
import Footer from '../Footer';
import associatepartners from '../../Assests/associatepartnersbg.png';

const DematAccount = () => {
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateStep1 = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        if (!email) {
            newErrors.email = 'Email address is required';
        } else if (!emailRegex.test(email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        if (!mobile) {
            newErrors.mobile = 'Mobile number is required';
        } else if (!mobileRegex.test(mobile)) {
            newErrors.mobile = 'Please enter a valid 10-digit Indian mobile number';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleRegister = (e) => {
        e.preventDefault();
        if (validateStep1()) {
            setIsSubmitting(true);
            setTimeout(() => {
                setIsSubmitting(false);
                window.location.href = `https://a.aonelink.in/ANGOne/UdkTIyO?mobileNumber=${mobile}&mobile=${mobile}`;
            }, 800);
        }
    };

    const pricingBenefits = [
        {
            id: 1,
            title: 'Referral and Earn',
            value: '₹100 to ₹750',
            description: 'Receive direct payouts ranging between 100 to 750 rupees per verified account referral.',
            badge: 'Highly Lucrative'
        },
        {
            id: 2,
            title: 'Equity Delivery',
            value: '₹20 or 0.1% max',
            description: 'INR 20 or 0.1% whichever is lower per executed order (minimum brokerage of INR 5 will be levied).',
            badge: 'Lowest Brokerage'
        },
        {
            id: 3,
            title: 'Intra-day Trading',
            value: '₹20 or 0.1% max',
            description: 'INR 20 or 0.1% whichever is lower per executed order. Optimize high frequency setups.',
            badge: 'Pro Trader'
        },
        {
            id: 4,
            title: 'Futures & Options',
            value: '₹20 Flat Rate',
            description: 'Futures, Options, Commodity, Currency: INR 20 flat charge per executed order.',
            badge: 'Flat Pricing'
        }
    ];

    return (
        <div className="min-h-screen bg-[#020410] text-slate-100 font-sans selection:bg-cyan-500 selection:text-black overflow-x-hidden">

            {/* Global CSS Styles for Vertical Scrolling Marquee */}
            <style>{`
        @keyframes scroll-vertical {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        .animate-scroll-vertical {
          animation: scroll-vertical 25s linear infinite;
        }
        .animate-scroll-vertical:hover {
          animation-play-state: paused;
        }
      `}</style>

            {/* Global Navigation Header */}
            <Header />

            {/* TRUSTED ASSOCIATE PARTNERS BANNER (Requested img: associatepartners) */}
            <div className="mt-16 bg-[#04081c]/40 border border-white/5 rounded-[2.5rem] p-8 sm:p-12 text-center space-y-6">
                <div className="max-w-xl mx-auto space-y-2">
                    {/* <h4 className="text-xs uppercase font-black tracking-[0.25em] text-cyan-400 font-mono">
                        Regulatory Infrastructure
                    </h4> */}
                    <h3 className="text-2xl font-extrabold text-white">
                        Secured Gateways & Associate Partners
                    </h3>
                    {/* <p className="text-xs text-slate-400 leading-relaxed">
                        We route all depository operations through regulated systems, working in tandem with elite national clearing houses and agents to secure your assets.
                    </p> */}
                </div>
                <div className="flex items-center justify-center pt-4">
                    <img
                        src={associatepartners}
                        alt="Associate Partners"
                        className="max-h-24 w-auto object-contain brightness-95 contrast-125 saturate-50 hover:brightness-100 hover:saturate-100 transition-all duration-500"
                    />
                </div>
            </div>

            {/* Main Split Screen Area */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch mt-8">

                    {/* LEFT HALF: Scrolling Pricing/Features */}
                    <div className="lg:col-span-6 flex flex-col justify-between space-y-8 bg-[#050a24]/30 backdrop-blur-xl border border-white/5 rounded-[2.5rem] p-6 sm:p-8 overflow-hidden h-[600px] relative">

                        {/* Top Fade Gradient */}
                        <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-[#020410] to-transparent z-20 pointer-events-none" />

                        {/* Bottom Fade Gradient */}
                        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#020410] to-transparent z-20 pointer-events-none" />

                        <div className="relative z-10 flex items-center justify-between border-b border-white/5 pb-4">
                            <div>
                                <h3 className="font-extrabold text-xl text-white">Brokerage & Incentives</h3>
                                <p className="text-xs text-slate-400">Hover over the cards below to pause auto-scrolling</p>
                            </div>
                            <span className="inline-flex items-center justify-center p-2 rounded-xl bg-cyan-950/40 border border-cyan-500/20 text-cyan-400 text-xs font-mono font-bold">
                                Live Schemes
                            </span>
                        </div>

                        {/* Scrolling List Container */}
                        <div className="flex-1 overflow-hidden relative">
                            <div className="absolute w-full space-y-4 animate-scroll-vertical">
                                {/* Loop 1 */}
                                {pricingBenefits.map((item) => (
                                    <div
                                        key={`loop1-${item.id}`}
                                        className="p-5 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-cyan-500/30 hover:bg-white/[0.04] transition-all duration-300 group cursor-pointer"
                                    >
                                        <div className="flex justify-between items-start mb-2.5">
                                            <div className="flex items-center space-x-3">
                                                <span className="w-8 h-8 rounded-lg bg-cyan-950/50 border border-cyan-500/20 flex items-center justify-center text-cyan-400 font-mono font-bold text-xs">
                                                    {item.id}
                                                </span>
                                                <h4 className="font-extrabold text-sm text-slate-200 group-hover:text-white transition-colors">
                                                    {item.title}
                                                </h4>
                                            </div>
                                            <span className="text-[10px] uppercase font-bold tracking-wider font-mono px-2 py-0.5 rounded-full bg-cyan-500/10 text-cyan-400 border border-cyan-500/10">
                                                {item.badge}
                                            </span>
                                        </div>
                                        <div className="text-xl sm:text-2xl font-black text-white group-hover:text-cyan-400 transition-colors mb-2">
                                            {item.value}
                                        </div>
                                        <p className="text-xs text-slate-400 leading-relaxed group-hover:text-slate-300 transition-colors">
                                            {item.description}
                                        </p>
                                    </div>
                                ))}

                                {/* Loop 2 (Identical loop for infinite seamless scrolling effect) */}
                                {pricingBenefits.map((item) => (
                                    <div
                                        key={`loop2-${item.id}`}
                                        className="p-5 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-cyan-500/30 hover:bg-white/[0.04] transition-all duration-300 group cursor-pointer"
                                    >
                                        <div className="flex justify-between items-start mb-2.5">
                                            <div className="flex items-center space-x-3">
                                                <span className="w-8 h-8 rounded-lg bg-cyan-950/50 border border-cyan-500/20 flex items-center justify-center text-cyan-400 font-mono font-bold text-xs">
                                                    {item.id}
                                                </span>
                                                <h4 className="font-extrabold text-sm text-slate-200 group-hover:text-white transition-colors">
                                                    {item.title}
                                                </h4>
                                            </div>
                                            <span className="text-[10px] uppercase font-bold tracking-wider font-mono px-2 py-0.5 rounded-full bg-cyan-500/10 text-cyan-400 border border-cyan-500/10">
                                                {item.badge}
                                            </span>
                                        </div>
                                        <div className="text-xl sm:text-2xl font-black text-white group-hover:text-cyan-400 transition-colors mb-2">
                                            {item.value}
                                        </div>
                                        <p className="text-xs text-slate-400 leading-relaxed group-hover:text-slate-300 transition-colors">
                                            {item.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="pt-4 border-t border-white/5 flex items-center space-x-3.5 text-xs text-slate-400">
                            <ShieldCheck className="w-4 h-4 text-cyan-400 shrink-0" />
                            <span>Full compliance parameters matching SEBI rules under broker partner regulations.</span>
                        </div>

                    </div>

                    {/* RIGHT HALF: Registration and OTP Form */}
                    <div className="lg:col-span-6 flex flex-col justify-between bg-gradient-to-b from-[#060e2b] to-[#04081c] border border-white/10 rounded-[2.5rem] p-6 sm:p-10 shadow-2xl relative overflow-hidden">
                        {/* Top glowing card overlay */}
                        <div className="absolute -top-16 -right-16 w-32 h-32 bg-cyan-500/20 rounded-full blur-2xl pointer-events-none" />

                        <div className="space-y-6 flex-1 flex flex-col justify-center">
                            <div className="space-y-2">
                                <h3 className="text-2xl font-black text-white">Open Demat Account</h3>
                                <p className="text-xs text-slate-400">
                                    Submit your details to start. We will redirect you to verify your mobile number.
                                </p>
                            </div>

                            <form onSubmit={handleRegister} className="space-y-5">
                                {/* Mobile Number Field */}
                                <div className="space-y-2">
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-400">
                                        Mobile Number
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                            <span className="text-slate-500 font-bold font-mono text-sm">+91</span>
                                        </div>
                                        <input
                                            type="tel"
                                            maxLength="10"
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
                                            placeholder="Enter 10-digit number"
                                            className={`w-full bg-slate-950/50 border ${errors.mobile ? 'border-red-500/50 focus:border-red-500' : 'border-white/10 focus:border-cyan-400'
                                                } rounded-2xl py-3.5 pl-14 pr-4 text-white text-sm font-semibold focus:outline-none focus:ring-1 focus:ring-cyan-400/25 transition-all font-mono`}
                                        />
                                    </div>
                                    {errors.mobile && (
                                        <p className="text-red-400 text-[10px] font-semibold">{errors.mobile}</p>
                                    )}
                                </div>

                                {/* Email Field */}
                                <div className="space-y-2">
                                    <label className="block text-xs font-bold uppercase tracking-wider text-slate-400">
                                        Email Address
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                            <Mail className="w-4.5 h-4.5 text-slate-500" />
                                        </div>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="name@company.com"
                                            className={`w-full bg-slate-950/50 border ${errors.email ? 'border-red-500/50 focus:border-red-500' : 'border-white/10 focus:border-cyan-400'
                                                } rounded-2xl py-3.5 pl-12 pr-4 text-white text-sm font-semibold focus:outline-none focus:ring-1 focus:ring-cyan-400/25 transition-all`}
                                        />
                                    </div>
                                    {errors.email && (
                                        <p className="text-red-400 text-[10px] font-semibold">{errors.email}</p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-black font-extrabold text-sm py-4 px-6 rounded-2xl flex items-center justify-center space-x-2 transition-all duration-300 shadow-lg shadow-cyan-500/20 disabled:opacity-50 select-none cursor-pointer mt-6"
                                >
                                    {isSubmitting ? (
                                        <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin" />
                                    ) : (
                                        <>
                                            <span>Proceed to Verification</span>
                                            <ArrowRight className="w-4 h-4" />
                                        </>
                                    )}
                                </button>
                            </form>

                            <div className="flex items-center justify-between text-[10px] text-slate-500 pt-2 font-mono">
                                <span className="flex items-center space-x-1">
                                    <Lock className="w-3 h-3 text-cyan-500" />
                                    <span>You will be redirected to Angel One for Verification</span>
                                </span>
                                <span>No hidden setup fees</span>
                            </div>
                        </div>
                    </div>

                </div>



            </main>

            {/* Global Footer */}
            <Footer />

        </div>
    );
};

export default DematAccount;